import styled from 'styled-components';

export const StyledResetPasswordButtons = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
`;
